
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA dans le Grand-Est dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads dans le Grand Est certifiée Google Partner, accompagne les entreprises régionales pour accroître leur visibilité sur Google et générer des prospects qualifiés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads dans le Grand-Est dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads dans le Grand Est certifiée Google Partner, accompagne les entreprises régionales pour accroître leur visibilité sur Google et générer des prospects qualifiés.",
        },
      ],
    };
  },
};
